import React from "react";

const CourseDetailsButton = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      style={{
        cursor: "pointer", 
      }}
      onClick={props.onClick}
    >
      <g clipPath="url(#clip0_3663_33551)">
        <path
          d="M22.61 3.57031H5.95001C4.62911 3.57031 3.57001 4.64131 3.57001 5.95031V22.6103C3.57001 23.9193 4.62911 24.9903 5.95001 24.9903H22.61C23.919 24.9903 24.99 23.9193 24.99 22.6103V5.95031C24.99 4.64131 23.919 3.57031 22.61 3.57031ZM19.04 15.4703H15.47V19.0403C15.47 19.6948 14.9345 20.2303 14.28 20.2303C13.6255 20.2303 13.09 19.6948 13.09 19.0403V15.4703H9.52001C8.86551 15.4703 8.33001 14.9348 8.33001 14.2803C8.33001 13.6258 8.86551 13.0903 9.52001 13.0903H13.09V9.52031C13.09 8.86581 13.6255 8.33031 14.28 8.33031C14.9345 8.33031 15.47 8.86581 15.47 9.52031V13.0903H19.04C19.6945 13.0903 20.23 13.6258 20.23 14.2803C20.23 14.9348 19.6945 15.4703 19.04 15.4703Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3663_33551">
          <rect width="28.56" height="28.56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CourseDetailsButton;
